import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ApplicationwizardComponent } from './components/applicationwizard/applicationwizard.component';
import { CommonModule } from '@angular/common';

import { WizardpageStep1GeneralComponent } from './components/wizardpages/wizardpage-step1-General/wizardpage-step1.component';
import { WizardpageStep2WelcomeComponent } from './components/wizardpages/wizardpage-step2-Welcome/wizardpage-step2.component';
import { WizardpageStep3ContactComponent } from './components/wizardpages/wizardpage-step3-Contact/wizardpage-step3.component';
import { WizardpageStep4EducationComponent } from './components/wizardpages/wizardpage-step4-Education/wizardpage-step4.component';
import { WizardpageStep5CredentialsComponent } from './components/wizardpages/wizardpage-step5-Credentials/wizardpage-step5.component';
import { WizardpageStep6EligibilityComponent } from './components/wizardpages/wizardpage-step6-Eligibility/wizardpage-step6.component';
import { WizardpageStep7AvailabilityComponent } from './components/wizardpages/wizardpage-step7-Availability/wizardpage-step7.component';
import { WizardpageStep8SpecialtyComponent } from './components/wizardpages/wizardpage-step8-Specialty/wizardpage-step8.component';
import { WizardpageStep9WorkHistoryComponent } from './components/wizardpages/wizardpage-step9-WorkHistory/wizardpage-step9.component';
import { WizardpageStep10ReferencesComponent } from './components/wizardpages/wizardpage-step10-References/wizardpage-step10.component';
// tslint:disable-next-line:max-line-length
import { WizardpageStep11AdditonalQuestComponent } from './components/wizardpages/wizardpage-step11-AdditionalQuests/wizardpage-step11.component';
// tslint:disable-next-line:max-line-length
import { WizardpageStep12BasicExamComponent } from './components/wizardpages/wizardpage-step12-BasicExam/wizardpage-step12.component';
import { WizardpageStep13PCAExamComponent } from './components/wizardpages/wizardpage-step13-PCAExam/wizardpage-step13.component';
// tslint:disable-next-line:max-line-length
import { WizardpageStep14CertifiedExamComponent } from './components/wizardpages/wizardpage-step14-CertifiedExam/wizardpage-step14.component';
import { WizardpageStep15HCAExamComponent } from './components/wizardpages/wizardpage-step15-HomeCareAideExam/wizardpage-step15.component';
// tslint:disable-next-line:max-line-length
import { WizardpageStep16PharmExamComponent } from './components/wizardpages/wizardpage-step16-PharmacologyExam/wizardpage-step16.component';
import { WizardpageStep17TermsComponent } from './components/wizardpages/wizardpage-step17-Terms/wizardpage-step17.component';
import { WizardpageStep18ReviewComponent } from './components/wizardpages/wizardpage-step18-Review/wizardpage-step18.component';



import {ResetEmailPageComponent} from './components/resetpages/resetemailpage/resetemailpage.component';

import {AuthenticationService} from '../app/services/authentication.service';
import { AuthGuard } from '../app/gaurds/auth.gaurd';

import { LoginComponent } from './login/login.component';
import { SignUpComponent } from './signup/signup.component';
import { ResetPasswordComponent } from './resetpassword/resetpassword.component';
import { TermsComponent } from './terms/terms.component';
import { ThankYouComponent } from './thankyou/thankyou.component';

import {FormsModule, ReactiveFormsModule } from '@angular/forms';
import {HttpClientModule } from '@angular/common/http';
import {NgxMaskModule } from 'ngx-mask';
import {MatStepperModule} from '@angular/material/stepper';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatDialogModule} from '@angular/material/dialog';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {ProgressSpinnerDialogComponent} from './components/progressspinnerdialog.component/progressspinnerdialog.component';



import {AppSettingsService} from '../app/services/appsettings.service';
import {PagesService} from '../app/services/pages.service';
import {MarketingService} from '../app/services/marketing.service';

//md add
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';



@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        SignUpComponent,
        TermsComponent,
        ThankYouComponent,
        ResetPasswordComponent,
        ApplicationwizardComponent,
        WizardpageStep1GeneralComponent,
        WizardpageStep2WelcomeComponent,
        WizardpageStep3ContactComponent,
        WizardpageStep4EducationComponent,
        WizardpageStep5CredentialsComponent,
        WizardpageStep6EligibilityComponent,
        WizardpageStep7AvailabilityComponent,
        WizardpageStep8SpecialtyComponent,
        WizardpageStep9WorkHistoryComponent,
        WizardpageStep10ReferencesComponent,
        WizardpageStep11AdditonalQuestComponent,
        WizardpageStep12BasicExamComponent,
        WizardpageStep13PCAExamComponent,
        WizardpageStep14CertifiedExamComponent,
        WizardpageStep15HCAExamComponent,
        WizardpageStep16PharmExamComponent,
        WizardpageStep17TermsComponent,
        WizardpageStep18ReviewComponent,
        ResetEmailPageComponent,
        ProgressSpinnerDialogComponent
    ],
    imports: [
        BrowserModule,
        CommonModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        MatStepperModule,
        MatToolbarModule,
        MatTooltipModule,
        MatSidenavModule,
        MatButtonModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatDialogModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,
        NgxMaskModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
              provide: TranslateLoader,
              useFactory: httpTranslateLoader,
              deps: [HttpClient]
            }
          })
    ],
    providers: [AuthGuard, {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        }, AppSettingsService, PagesService, AuthenticationService, MarketingService],
    bootstrap: [AppComponent]
})

export class AppModule { }

//md add
export function httpTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http);
  }
